// validatorPlugin.js
const validatorPlugin = {
    install(app, options = {}) {
        const validatePhone = (value) => /^1[3-9]\d{9}$/.test(value);

        // 最大长度验证
        const validateMaxLength = (value) => 6 <= value.length && value.length <= 16;
        const validateMaxLengthName = (value) => 2 <= value.length && value.length <= 10;

        // 将方法挂载到全局属性
        app.config.globalProperties.$validator = {
            phone: validatePhone,
            maxLength: validateMaxLength,
            maxLengthName: validateMaxLengthName,

            // 可以添加更多验证方法
        };
        // 通用验证指令
        app.directive('validate', {
            mounted(el, binding) {
                const { type, maxLength, errorClass = 'error' } = binding.value || {};

                el.addEventListener('blur', () => {
                    const value = el.value;
                    let isValid = true;

                    if (type === 'phone') {
                        isValid = validatePhone(value);
                    } else if (type === 'maxLength' && maxLength) {
                        isValid = validateMaxLength(value, maxLength);
                    }

                    if (!isValid) {
                        el.classList.add(errorClass);
                        // 触发自定义事件
                        el.dispatchEvent(new CustomEvent('validation-error', {
                            detail: { type, isValid }
                        }));
                    } else {
                        el.classList.remove(errorClass);
                        // 触发自定义事件
                        el.dispatchEvent(new CustomEvent('validation-success', {
                            detail: { type, isValid }
                        }));
                    }

                    // 如果有回调函数则调用
                    if (typeof binding.arg === 'function') {
                        binding.arg(isValid);
                    }
                });
            }
        });
    }
};

export default validatorPlugin;